// src/pages/PageMenu/SettingsMenu.jsx
// قائمة الإعدادات — بالتصميم الموحّد (MenuKit) مع دعم الترجمة

import React from "react";
import { useAuth } from "../../context/AuthContext";
import { MenuPage } from "../../components/Menu/MenuKit";

import SettingsIcon from "@mui/icons-material/Settings";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import PercentIcon from "@mui/icons-material/Percent";
import PaymentsIcon from "@mui/icons-material/Payments";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PrintIcon from "@mui/icons-material/Print";
import TuneIcon from "@mui/icons-material/Tune";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import DevicesOutlinedIcon from "@mui/icons-material/DevicesOutlined";

export default function SettingsMenu() {
  const { hasAnyPermission } = useAuth();
  // نفس مفاتيح السيرفر ([RequirePermission]) — يكفي أي واحد منها، والمالك يرى الكل
  const canAny = (...keys) => hasAnyPermission(keys);

  const sections = [
    {
      key: "system",
      titleKey: "settingsMenu.systemSection", titleFallback: "إعدادات النظام",
      icon: <TuneIcon />, color: "#4F46E5",
      items: [
        canAny("Settings.View", "Settings.Edit") && { key: "general", nameKey: "settingsMenu.generalSettings", nameFallback: "الإعدادات العامة", icon: <SettingsIcon />, color: "#4F46E5", link: "/settings" },
        canAny("Settings.Edit") && { key: "pos", nameKey: "settingsMenu.posSettings", nameFallback: "إعدادات نقطة البيع", icon: <PointOfSaleIcon />, color: "#7C3AED", link: "/pos-settings" },
        canAny("Pos.Devices.Manage", "Role.Manage") && { key: "posDevices", nameKey: "settingsMenu.posDevices", nameFallback: "أجهزة نقطة البيع", icon: <DevicesOutlinedIcon />, color: "#0D9488", link: "/pos/devices" },
        canAny("Zatca.View", "Zatca.Manage", "Settings.View", "Settings.Edit") && { key: "zatca", nameKey: "settingsMenu.zatcaSettings", nameFallback: "إعدادات الفاتورة الإلكترونية", icon: <VerifiedUserOutlinedIcon />, color: "#059669", link: "/zatca-settings" },
        canAny("GlSettings.View", "GlSettings.Edit") && { key: "gl", nameKey: "settingsMenu.glSettings", nameFallback: "توجيه الحسابات", icon: <AccountTreeOutlinedIcon />, color: "#2563EB", link: "/gl-settings" },
      ],
    },
    {
      key: "advanced",
      titleKey: "settingsMenu.advancedSection", titleFallback: "خيارات متقدمة",
      icon: <BuildOutlinedIcon />, color: "#D97706",
      items: [
        canAny("Settings.View", "Settings.Edit") && { key: "vat", nameKey: "settingsMenu.vatTypes", nameFallback: "أنواع الضرائب", icon: <PercentIcon />, color: "#D97706", link: "/vat-types" },
        canAny("PaymentMethod.View", "PaymentMethod.Manage", "Settings.Edit") && { key: "pm", nameKey: "settingsMenu.paymentMethods", nameFallback: "طرق الدفع", icon: <PaymentsIcon />, color: "#DB2777", link: "/payment-methods" },
        canAny("InvoiceType.Manage", "Settings.Edit") && { key: "types", nameKey: "settingsMenu.invoiceTypes", nameFallback: "أنواع الفواتير", icon: <ReceiptIcon />, color: "#0891B2", link: "/invoice-types" },
        canAny("PrintLayout.Manage", "Settings.Edit") && { key: "print", nameKey: "settingsMenu.printLayout", nameFallback: "تصميم الفواتير", icon: <PrintIcon />, color: "#475569", link: "/print-layout" },
        canAny("Promotion.View", "Promotion.Manage") && { key: "promotions", nameKey: "settingsMenu.promotions", nameFallback: "العروض الترويجية", icon: <LocalOfferOutlinedIcon />, color: "#E11D48", link: "/promotions" },
      ],
    },
  ];

  return (
    <MenuPage
      titleKey="settingsMenu.title" titleFallback="الإعدادات"
      icon={<SettingsOutlinedIcon />}
      sections={sections}
    />
  );
}
